import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Route } from '../../../models/route.model';
import { PurchaseService } from '../../../services/purchase.service';
import { AuthService } from '../../../services/auth.service';
import { ModalNotificationService } from '../../../_shared/modal-notification/modal-notification.service';

@Component({
  selector: 'app-route',
  templateUrl: './route.component.html',
  styleUrls: ['./route.component.scss']
})
export class RouteComponent implements OnInit {

  direction = 'Entrada';
  routes: Route[] = [];
  searchTerm = '';
  selected: Route = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private purchaseService: PurchaseService,
    private authService: AuthService,
    private modal: ModalNotificationService,
  ) {
    this.route.data.subscribe((data) => this.routes = data.routes);

    this.authService.currentUser.subscribe((user) => {
      if (user.booking_limit === 0) {
        this.modal.warning({
          title: 'Límite excedido',
          body: `Lo sentimos, no es posible tener más de ${user.company.booking_limit} activos.`,
        });
      }
    });
  }

  ngOnInit(): void {
    this.purchaseService.set('route', null);
  }

  setDirection(direction: string) {
    this.direction = direction;
  }

  chooseRoute(route: Route): void {
    this.selected = route;
    this.purchaseService.set('route', route);
    this.router.navigate(['steps/dates']);
  }

  mapDirection(direction: string): string {
    if (direction === 'Entrada') return 'inbound';
    if (direction === 'Salida') return 'outbound';
    return '';
  }

  getDirection(route: Route): string {
    return (route as any).direction;
  }

  getDirectionLabel(route: Route): string {
    const dir = this.getDirection(route);
    if (dir === 'inbound') return 'Entrada';
    if (dir === 'outbound') return 'Salida';
    return '';
  }

  getBadgeClass(route: Route): string {
    const dir = this.getDirection(route);

    if (dir === 'inbound') return 'bg-primary';
    if (dir === 'outbound') return 'bg-success';

    return 'bg-secondary';
  }

getServiceDays(route: any): string {
  return (route.service_days || []).join(', ');
}

filteredRoutes(): Route[] {
  const term = this.searchTerm.toLowerCase();
  const mappedDirection = this.mapDirection(this.direction);

  return this.routes
    .filter(route =>
      !mappedDirection || this.getDirection(route) === mappedDirection
    )
    .filter(route =>
      route.name.toLowerCase().includes(term)
    )
    .filter(route =>
      this.getTimes(route.name).length > 0
    )
    .sort((a, b) => {
      const indexA = a.name.toLowerCase().indexOf(term);
      const indexB = b.name.toLowerCase().indexOf(term);

      if (indexA === -1) return 1;
      if (indexB === -1) return -1;

      return indexA - indexB;
    })
//    .slice(0, 50);
}


  getBaseName(name: string): string {
    return name.split('(')[0].trim();
  }

getTimes(name: string): string[] {
  const match = name.match(/\((.*?)\)/);

  if (!match || !match[1]) {
    return [];
  }

  return match[1]
    .split('/')
    .map(time => time.trim())
    .filter(time => /^\d{2}:\d{2}$/.test(time));
}

isNewRoute(route: Route): boolean {
  if (!route.created_at) {
    return false;
  }

  const createdAt = new Date(route.created_at).getTime();
  const now = Date.now();

  const diffDays = (now - createdAt) / (1000 * 60 * 60 * 24);

  return diffDays <= 30;
}


}